import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'maskedPrivateMessagesGroupName'
})
export class MaskedPrivateMessagesNamePipe implements PipeTransform {

  userType = localStorage.getItem('type');
  isManager = localStorage.getItem('isManager');

  transform(name: string) {
    // console.log(`userType: ${this.userType}, isManager: ${this.isManager}, name is ${name}, userId is ${userId}`);
    let result = '';
    if (!!name) {
      result = (this.userType === 'admin' || this.isManager === 'true') ? name : this.maskedPrivateMessagesGroupName(name);
    }
    return result;
  }

  maskedPrivateMessagesGroupName(name: string) {
    let result = name;
    const memberNames = name.split(',');
    const maskedMemberNames = memberNames
    .map(member => member.trim())
    .map(member => {
      const [ firstName, lastName ] = member.split(' ');
      return `${firstName} ${lastName.substring(0, 1)}`;
    });
    result = maskedMemberNames.join(',');
    return result;
  }
}
